/*! @wharfkit/abicache v4.0.0-rc6 | BSD-3-Clause | Copyright (c) 2023 Greymass Inc. | https://github.com/wharfkit/js */
import { ABI } from "@wharfkit/antelope";
//#region src/abi.ts
var ABICache = class ABICache {
	constructor(client) {
		this.client = client;
		this.cache = new Map();
		this.pending = new Map();
		this.partial = new Set();
	}
	async getAbi(account) {
		const key = String(account);
		const record = this.cache.get(key);
		if (record && !this.partial.has(key)) return record;
		let getAbi = this.pending.get(key);
		if (!getAbi) {
			getAbi = this.client.v1.chain.get_raw_abi(account).finally(() => {
				this.pending.delete(key);
			});
			this.pending.set(key, getAbi);
		}
		const response = await getAbi;
		if (response.abi) {
			const chainAbi = ABI.from(response.abi);
			const resolved = record ? ABICache.merge(chainAbi, record, chainAbi.version) : chainAbi;
			this.cache.set(key, resolved);
			this.partial.delete(key);
			return resolved;
		} else if (record) return record;
		else throw new Error(`ABI for ${key} could not be loaded.`);
	}
	setAbi(account, abiDef, merge = false) {
		const key = String(account);
		const abi = ABI.from(abiDef);
		const existing = this.cache.get(key);
		if (merge && existing) this.cache.set(key, ABICache.merge(existing, abi, abi.version));
		else {
			this.cache.set(key, abi);
			if (merge) this.partial.add(key);
			else this.partial.delete(key);
		}
	}
	static merge(base, addition, version) {
		return ABI.from({
			action_results: mergeAndDeduplicate(base.action_results, addition.action_results),
			types: mergeAndDeduplicate(base.types, addition.types, "new_type_name"),
			structs: mergeAndDeduplicate(base.structs, addition.structs),
			actions: mergeAndDeduplicate(base.actions, addition.actions),
			tables: mergeAndDeduplicate(base.tables, addition.tables),
			ricardian_clauses: mergeAndDeduplicate(base.ricardian_clauses, addition.ricardian_clauses, "id"),
			variants: mergeAndDeduplicate(base.variants, addition.variants),
			version
		});
	}
};
function mergeAndDeduplicate(array1, array2, byField = "name") {
	return array2.reduce((acc, current) => {
		if (!acc.some((obj) => String(obj[byField]) === String(current[byField]))) acc.push(current);
		return acc;
	}, array1.slice());
}
//#endregion
//#region src/index.ts
var src_default = ABICache;
//#endregion
export { ABICache, src_default as default };

//# sourceMappingURL=abicache.m.js.map